/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';

import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { listTemplates, selectTemplate, toggleLoadingDocument } from 'store/slices/artworks';
import { TemplateCards } from 'modules/artwork/template/TemplateCards';

export const NewArtwork = (props) => {
  const dispatch = useDispatch();

  const { close } = props;
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const { value: templates, loading: loadingTemplates } = useSelector((state) => state.artworks.templates);

  const handleCreate = () => {
    dispatch(toggleLoadingDocument(true));
    dispatch(selectTemplate(selectedTemplate));
    close();
  };

  useEffect(() => {
    dispatch(listTemplates());
  }, [dispatch]);

  return (
    <DrawerContent>
      <DrawerContent.Header
        title={'Choose a template'}
        loading={loadingTemplates}
        hideClose
      />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              p: 0.1,
            }}
          >
            {templates.length < 1 && !loadingTemplates && (
              <Typography
                variant="body2"
                sx={{ paddingTop: 3 }}
              >
                No linked templates found.
              </Typography>
            )}

            <TemplateCards
              templates={templates}
              selectedTemplate={selectedTemplate}
              onClick={setSelectedTemplate}
            />
          </Box>
        </DrawerContent.Content>
        <DrawerContent.ActionButtons
          disabled={!selectedTemplate}
          submitButtonText="Next"
          submit={handleCreate}
          hideClose
        />
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
